import AziendaNavContainer from "../features/azienda/AziendaNavContainer";
import React, {useEffect} from "react";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectIdAzienda, selectIdAziendaMaster, selectToken, selectUser} from "@commons/core.slice";
import {useQueryFilter} from "@components/dataTable/customHooks";
import {usePagination} from "@components/dataTable/usePagination";
import {TabellaSpool, useDeleteFileMutation, useGetTabellaSpoolQuery} from "@commons/features/varie/spool.api";
import DTTitle from "../components/dataTable/TableTitle";
import DTTable from "../components/dataTable/Table";
import * as Buttons from "../components/dataTable/buttons";
import {Custom} from "@components/dataTable/buttons";
import Pagination from "../components/dataTable/Pagination";
import {SpoolRecord} from "@commons/mapping/SpoolRecord";
import {useEditor} from "../core/editor";
import TooltipEx from "../components/Tooltip";
import {formatDt} from "@commons/utils/util";
import Loading from "../components/dataTable/Loading";
import {IconAlertTriangleFilled, IconDownload, IconFolder, IconFolderCancel, IconFolderOpen, IconRefresh} from "@tabler/icons-react";

const SpoolPage: React.FC = () => {

    const token = useAppSelector(selectToken);
    const idAzienda = useAppSelector(selectIdAzienda);
    const idAziendaMaster = useAppSelector(selectIdAziendaMaster);
    const user = useAppSelector(selectUser);

    const userPolicy = user && (user.userClass === 'ADMIN' || user.userClass === 'ALIAS' || user.userClass === 'SUPER');

    // const [update, setUpdate] = useState<boolean>(false)

    const pagination = usePagination('', 1, 10);
    const {page, setPage, pageLength, setPageLength, search, setSearch} = pagination;

    const {filter, setFilter, skip} = useQueryFilter<TabellaSpool>({
        idAziendaMaster: idAziendaMaster,
        idAzienda: idAzienda,
        nowId: (new Date()).getTime()
    } as TabellaSpool, pagination);
    const {data, isLoading, isFetching} = useGetTabellaSpoolQuery(filter, {skip: (skip || !idAziendaMaster || !idAzienda), refetchOnMountOrArgChange: true});

    const {URI, deleteResource} = useEditor<SpoolRecord>(
        undefined,
        undefined,
        undefined,
        useDeleteFileMutation()[0] //URI http://fpnet.local/FPNet2021/tool/2089-2089/spool/348609
    )

    useEffect(() => {
        if (idAzienda && idAziendaMaster) {
            setFilter(filter => ({
                ...filter, idAzienda: idAzienda, idAziendaMaster: idAziendaMaster, nowId: (new Date()).getTime(),
            }));
        }
    }, [idAziendaMaster, idAzienda, setFilter])

    /*    useEffect(() => {
            setFilter(filter => ({
                ...filter, nowId: (new Date()).getTime(),
            }));
            setUpdate(false)
        }, [update, setFilter])*/

    const updateElencoFiles = function () {
        setFilter(filter => ({
            ...filter, nowId: (new Date()).getTime(),
        }));
    }

    return (<>
        <AziendaNavContainer>
            <Loading loading={isLoading || isFetching}>

                {/*RESP. HEADER: fpnet-spoolsize*/}
                <div className="bg-white px-4 py-3 rounded-lg shadow mt-4">
                    <div className="w-full mb-2">Dimensione spool: {data ? ((data.spoolSize / 1024).toFixed(2)) : '0'}&nbsp;MB</div>
                    <div className="flex justify-end">
                        <button onClick={() => updateElencoFiles() //setUpdate(true)
                        }
                                className="btnPrimary">
                            <IconRefresh className="h-5 w-5"/>&nbsp;Aggiorna "elenco files"
                        </button>
                    </div>
                </div>

                <DTTitle id="elencoFileSpool" title="Elenco files" {...{currentPageLength: pageLength, setPageLength, currentSearch: search, setSearch}}/>

                <DTTable<SpoolRecord> dtSchema={data}
                                      header={<>
                                          <th scope="col" className="tableTH">
                                              Data &amp; ora
                                          </th>
                                          <th scope="col" className="tableTH">
                                              Utente
                                          </th>
                                          <th scope="col" className="tableTH">
                                              File
                                          </th>
                                          <th scope="col" className="tableTH !whitespace-pre-wrap">
                                              Descrizione
                                          </th>
                                          <th scope="col" className="tableTH">
                                              Antepr.
                                          </th>
                                          <th scope="col" className="flex-wrap py-3.5 w-14"/>
                                      </>}
                                      rows={({item, index, isMobile, currentRow, register}) => {
                                          const {key, ...params} = register(item.idSplf + '_' + item.fileType, index, item.URI === URI);
                                          return <tr key={key} {...params}>
                                              <td className="tableTD !whitespace-normal">
                                                  {item.insertTrace?.timeStamp ? formatDt(item.insertTrace?.timeStamp, 'dd/LL/yyyy HH:mm:ss') : '???'}
                                              </td>
                                              <td className="tableTD">
                                                  {item.insertTrace?.userName}
                                              </td>
                                              <td className="tableTD">
                                                  {item.fileName}
                                              </td>
                                              <td className="tableTD !whitespace-normal">
                                                  {item.descrizione}
                                              </td>
                                              <td className="tableTD">
                                                  {(item.stato === 'NON_DISPONIBILE' || item.stato === 'PRESENTE' || item.stato === 'PRESENTE_SCARICATO') &&
                                                      <div
                                                          className={`w-fit ${(item.fileType === 'PDF' && item.stato !== 'NON_DISPONIBILE') ? 'cursor-pointer hover:text-gray-700' : 'pointer-events-none opacity-50 cursor-not-allowed'}`}>
                                                          <a href={item.URI ? item.URI : undefined} target="_blank">
                                                              {item.stato === 'PRESENTE' && <IconFolder className="h-5 w-5"/>}
                                                              {item.stato === 'PRESENTE_SCARICATO' && <IconFolderOpen className="h-5 w-5"/>}
                                                          </a>

                                                          {(item.fileType === 'PDF' && item.stato === 'NON_DISPONIBILE') && <IconFolderCancel className="h-5 w-5"/>}
                                                      </div>
                                                  }

                                                  {(item.stato !== 'NON_DISPONIBILE' && item.stato !== 'PRESENTE' && item.stato !== 'PRESENTE_SCARICATO') &&
                                                      <TooltipEx tooltip={'Errore nella generazione del file!'}>
                                                          <Custom Icon={IconAlertTriangleFilled} btnClass="text-red-500 hover:text-red-700" onAction={() => {
                                                          }}/>
                                                      </TooltipEx>
                                                  }
                                              </td>
                                              <td className="align-middle text-sm min-w-[80px] pr-2">
                                                  <Buttons.Visibility visible={isMobile || index === currentRow}>

                                                      {(item.stato && item.stato !== 'NON_DISPONIBILE') && <>
                                                          <a href={item.URI ? (`${item.URI}?${item.fileType !== 'PDF' ? 'contentDisposition=ATTACHMENT&' : ''}auth_token=${token.token}&now=${Date.now()}${item.fileType === 'PDF' ? '&type=attachment' : ''}`) : undefined}
                                                             className="mx-1">
                                                              <IconDownload className="h-5 w-5 text-sky-400 hover:text-sky-600"/>
                                                          </a>
                                                          {/*{userPolicy && <a href="#" className="mx-1">
                                                              <DocumentDuplicateIcon className="h-5 w-5 text-green-500"/>
                                                          </a>}*/}
                                                          <Buttons.Delete onConfirm={() => {
                                                              deleteResource(item.URI!);
                                                              // setUpdate(true);
                                                              updateElencoFiles();
                                                          }}/>
                                                      </>
                                                      }
                                                  </Buttons.Visibility>
                                              </td>
                                          </tr>

                                      }
                                      }
                />

                <Pagination dataTables={data} currentPage={page} setPage={setPage} currentPageLength={pageLength}></Pagination>
            </Loading>
        </AziendaNavContainer>

    </>)
}
export default SpoolPage;